import { v4 } from 'uuid';
import { Button } from '@/components/ui/button';
import { Dialog, DialogContent, DialogTitle } from '@/components/ui/dialog';

export const SeamlessResultDialog = ({ isOpen, seamlessResult, setIsOpen }) => {
    const imageData = typeof seamlessResult === 'string' ? seamlessResult : seamlessResult?.image;
    return (
        <Dialog open={isOpen} onOpenChange={(open) => setIsOpen(open)}>
            <DialogContent className="flex h-[96vh] w-[96vw] max-w-none items-center justify-center sm:max-w-none">
                <DialogTitle className="sr-only">Download</DialogTitle>
                {imageData && (
                    <>
                        <img
                            src={`data:image/png;base64,${imageData}`}
                            alt="Seamless Texture"
                            className="max-h-[88vh] max-w-[90vw] object-contain"
                        />
                        <a
                            href={`data:image/png;base64,${imageData}`}
                            download={`${v4()}.jpg`}
                            className="absolute bottom-4 end-4"
                        >
                            <Button variant="outline">Download</Button>
                        </a>
                    </>
                )}
            </DialogContent>
        </Dialog>
    );
};
